import React from "react";
import { useState } from "@wordpress/element";
import Simple from "../simple/simple";
import SistemaPisos from "./sistema-pisos";

const Pisos = ({ posts }) => {

    const classNameSpace = 'c-simple-cal';
    const [stepOne, setStepOne] = useState('');

	return (
        <section className={classNameSpace+'__content'}>

            <div className={classNameSpace+'__select-product ' + classNameSpace +'--backgroun-white'}>
                <div className={classNameSpace + '__step-one'}>
                    <div className={classNameSpace + '__title-calc'}>
                        <h2 className={classNameSpace + '__title'}>
                            <strong className='number-step'>1</strong>
                            Selecciona un producto o un sistema para <br/> protección de pisos
                        </h2>
                    </div>

                    <div className={classNameSpace + '__product-selec'}>

                        <select  className={classNameSpace + '__selector'} 
                            value={stepOne} 
                                onChange={(e) => { setStepOne(e.target.value) }
                            }
                        >
                            <option value='0'>Seleccionar</option>
                            <option value="producto">producto</option>
                            <option value="sistema-de-pinturas">Sistema de pinturas</option>
                        </select>

                    </div>

                </div>
            </div>

           {stepOne == "producto" &&
                <Simple posts={posts} typeCalc={'pisos'} number={2}/>
           }   
           {
            stepOne =="sistema-de-pinturas" &&
                <SistemaPisos posts={posts} />
           }         
        </section>
    )
}

export default Pisos;